import HGLink from '../index'
import { LinkProps } from '../links.types'

export default function LinkHome({ children, href, ...props }: LinkProps) {
  return (
    <HGLink href={href || getHomeHref()} aria-label='go to homepage' {...props}>
      {children}
    </HGLink>
  )
}

export function getHomeHref() {
  return '/'
}
